import { render, staticRenderFns } from "./overlayMenu.vue?vue&type=template&id=1b5d2c6f&scoped=true"
import script from "./overlayMenu.vue?vue&type=script&lang=js"
export * from "./overlayMenu.vue?vue&type=script&lang=js"
import style0 from "./overlayMenu.vue?vue&type=style&index=0&id=1b5d2c6f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d2c6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5d2c6f')) {
      api.createRecord('1b5d2c6f', component.options)
    } else {
      api.reload('1b5d2c6f', component.options)
    }
    module.hot.accept("./overlayMenu.vue?vue&type=template&id=1b5d2c6f&scoped=true", function () {
      api.rerender('1b5d2c6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlayMenu.vue"
export default component.exports